// Bezpečnostní pauza posouvá odhady příjezdu: 15 min pauzy = +15 min na ETA
// všech zbývajících zastávek. Server ETA (stop.eta) pauzu nezná, posun se
// drží lokálně per směna (localStorage) a přičítá při zobrazení.

const key = (shiftId: string) => `routera.pause.${shiftId}`;

interface PauseState {
  /** Nasbírané ms ukončených pauz. */
  acc: number;
  /** ISO začátku běžící pauzy; null = pauza neběží. */
  since: string | null;
}

function read(shiftId: string): PauseState {
  try {
    const raw = localStorage.getItem(key(shiftId));
    if (raw) return JSON.parse(raw) as PauseState;
  } catch { /* poškozený záznam = od nuly */ }
  return { acc: 0, since: null };
}

function write(shiftId: string, s: PauseState) {
  localStorage.setItem(key(shiftId), JSON.stringify(s));
}

export function pauseStarted(shiftId: string) {
  const s = read(shiftId);
  if (!s.since) write(shiftId, { ...s, since: new Date().toISOString() });
}

export function pauseEnded(shiftId: string) {
  const s = read(shiftId);
  if (s.since) {
    write(shiftId, { acc: s.acc + (Date.now() - new Date(s.since).getTime()), since: null });
  }
}

/** Kolik minut pauzy směna nasbírala (včetně právě běžící). */
export function pauseMinutes(shiftId: string): number {
  const s = read(shiftId);
  const running = s.since ? Date.now() - new Date(s.since).getTime() : 0;
  return Math.floor((s.acc + running) / 60_000);
}

/** Kolik sekund běží aktuální pauza (0 = neběží) — pro živý čítač v UI. */
export function pauseRunningSeconds(shiftId: string): number {
  const s = read(shiftId);
  return s.since ? Math.floor((Date.now() - new Date(s.since).getTime()) / 1000) : 0;
}

/** „HH:MM" + minuty → „H:MM"; nevalidní vstup vrací beze změny. */
export function shiftHhMm(hhmm: string, addMin: number): string {
  const m = /^(\d{1,2}):(\d{2})$/.exec(hhmm.trim());
  if (!m || addMin <= 0) return hhmm;
  const total = (Number(m[1]) * 60 + Number(m[2]) + addMin) % (24 * 60);
  return `${Math.floor(total / 60)}:${String(total % 60).padStart(2, "0")}`;
}
